import Rockets from '../components/Rockets/Rockets';

const RocketsPage = () => (
  <div>
    <Rockets />
  </div>
);

export default RocketsPage;
